import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { getBaseUrl } from "../global/Globalapi";
const AccountMaster = () => {
  // API Base URL
  // const API_BASE_URL = 'http://localhost:5000';
const API_BASE_URL = getBaseUrl();
  // State for form data - matching database column names
  const [formData, setFormData] = useState({
    region_id: '',
    branch_id: '',
    acc_type_id: '',
    acc_name: '',
    account_status: 'active',
    account_code: '',
    title: '',
    comp_name: '',
    comp_phone: '',
    comp_email: '',
    comp_state: '',
    comp_country: '',
    credit_limit: '',
    reference: '',
    comp_pincode: '',
    comp_website: '',
    comp_add: '',
    d_add: '',
    comp_gst: '',
    comp_pan: '',
    type: '',
    Billwise: 'No',
    e_invoice: 0
  });

  // State for dropdown data
  const [regions, setRegions] = useState([]);
  const [branches, setBranches] = useState([]);
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);

  // State for account list
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [editId, setEditId] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Fetch initial data
  useEffect(() => {
    fetchRegions();
    fetchBranches();
    fetchAccounts();
    fetchAccountTypes();
  }, []);

  // Filter branches when region changes
  useEffect(() => {
    if (formData.region_id) {
      const filtered = branches.filter(branch => branch.region_id === parseInt(formData.region_id));
      setFilteredBranches(filtered);
    } else {
      setFilteredBranches([]);
    }
  }, [formData.region_id, branches]);

  // Fetch regions from API
  const fetchRegions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/regionmaster`);
      setRegions(response.data);
    } catch (error) {
      console.error('Error fetching regions:', error);
    }
  };

  // Fetch branches from API
  const fetchBranches = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/branchmaster`);
      setBranches(response.data);
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  // Fetch accounts from API
  const fetchAccounts = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/accountmaster`);
      setAccounts(response.data);
    } catch (error) {
      console.error('Error fetching accounts:', error);
    }
  };

  // Fetch account types from API
  const fetchAccountTypes = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/accounttype`);
      setAccountTypes(response.data);
    } catch (error) {
      console.error('Error fetching account types:', error);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    
    if (type === 'radio') {
      setFormData(prev => ({ ...prev, [name]: value }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      if (editId) {
        // Update existing account
        await axios.put(`${API_BASE_URL}/api/accountmaster/${editId}`, formData, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        });
        setMessage({ type: 'success', text: 'Account updated successfully!' });
      } else {
        // Create new account
        await axios.post(`${API_BASE_URL}/api/accountmaster`, formData, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        });
        setMessage({ type: 'success', text: 'Account saved successfully!' });
      }
      fetchAccounts(); // Refresh the list
      handleReset();
    } catch (error) {
      console.error('Error saving account:', error);
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Error saving account' 
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle delete account
  const handleDelete = async (accountId) => {
    if (!window.confirm('Are you sure you want to delete this account?')) return;
    
    try {
      await axios.delete(`${API_BASE_URL}/api/accountmaster/${accountId}`);
      setMessage({ type: 'success', text: 'Account deleted successfully!' });
      fetchAccounts(); // Refresh the list
    } catch (error) {
      console.error('Error deleting account:', error);
      const errorMsg = error.response?.data?.message || 'Error deleting account';
      setMessage({ type: 'error', text: errorMsg });
    }
  };

  // Reset form
  const handleReset = () => {
    setEditId(null);
    setFormData({
      region_id: '',
      branch_id: '',
      acc_type_id: '',
      acc_name: '',
      account_status: 'active',
      account_code: '',
      title: '',
      comp_name: '',
      comp_phone: '',
      comp_email: '',
      comp_state: '',
      comp_country: '',
      credit_limit: '',
      reference: '',
      comp_pincode: '',
      comp_website: '',
      comp_add: '',
      d_add: '',
      comp_gst: '',
      comp_pan: '',
      type: '',
      Billwise: 'No',
      e_invoice: 0
    });
  };

  // Handle edit account
  const handleEdit = (account) => {
    setEditId(account.acc_master_id);
    setFormData({
      region_id: account.region_id || '',
      branch_id: account.branch_id || '',
      acc_type_id: account.acc_type_id || '',
      acc_name: account.acc_name || '',
      account_status: account.account_status || 'active',
      account_code: account.account_code || '',
      title: account.title || '',
      comp_name: account.comp_name || '',
      comp_phone: account.comp_phone || '',
      comp_email: account.comp_email || '',
      comp_state: account.comp_state || '',
      comp_country: account.comp_country || '',
      credit_limit: account.credit_limit || '',
      reference: account.reference || '',
      comp_pincode: account.comp_pincode || '',
      comp_website: account.comp_website || '',
      comp_add: account.comp_add || '',
      d_add: account.d_add || '',
      comp_gst: account.comp_gst || '',
      comp_pan: account.comp_pan || '',
      type: account.type || '',
      Billwise: account.Billwise || 'No',
      e_invoice: account.e_invoice || 0
    });
    
    // Scroll to form
    window.scrollTo({ top: document.querySelector('.form-section')?.offsetTop || 0, behavior: 'smooth' });
  };

  // Pagination calculations
  const totalPages = Math.ceil(accounts.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAccounts = accounts.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '8px 0 15px 0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '15px',
    boxSizing: 'border-box'
  };

  const labelStyle = {
    fontWeight: '600',
    display: 'block',
    marginBottom: '5px',
    color: '#555',
    fontSize: '14px'
  };

  const requiredStar = {
    color: 'red',
    marginLeft: '4px'
  };

  const paginationButtonStyle = {
    padding: '8px 16px',
    margin: '0 5px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  };

  return (
    <div style={{ maxWidth: '1000px', margin: '50px auto', padding: '20px' }}>
      {/* Account List Section - At the top */}
      <div style={{
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        marginBottom: '30px'
      }}>
        <h3 style={{ 
          marginBottom: '20px', 
          color: '#333',
          borderBottom: '2px solid #2196F3',
          paddingBottom: '10px'
        }}>
          Account List
        </h3>

        {message.text && (
          <div style={{
            padding: '12px',
            marginBottom: '20px',
            borderRadius: '4px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24',
            border: message.type === 'success' ? '1px solid #c3e6cb' : '1px solid #f5c6cb',
            fontSize: '14px'
          }}>
            {message.text}
          </div>
        )}

        {accounts.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#666' }}>No accounts found.</p>
        ) : (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '14px'
              }}>
                <thead>
                  <tr style={{ backgroundColor: '#b91c1c', color: 'white' }}>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>S.No</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Account Name</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Company Name</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Phone</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Email</th>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Status</th>
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentAccounts.map((account, index) => (
                    <tr key={account.acc_master_id} style={{ 
                      backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
                      borderBottom: '1px solid #ddd'
                    }}>
                      <td style={{ padding: '12px' }}>{indexOfFirstItem + index + 1}</td>
                      <td style={{ padding: '12px' }}>{account.acc_name}</td>
                      <td style={{ padding: '12px' }}>{account.comp_name}</td>
                      <td style={{ padding: '12px' }}>{account.comp_phone}</td>
                      <td style={{ padding: '12px' }}>{account.comp_email}</td>
                      <td style={{ padding: '12px' }}>
                        <span style={{
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          backgroundColor: account.account_status === 'active' ? '#d4edda' : '#f8d7da',
                          color: account.account_status === 'active' ? '#155724' : '#721c24'
                        }}>
                          {account.account_status}
                        </span>
                      </td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <button
                          onClick={() => handleEdit(account)}
                          style={{
                            backgroundColor: '#2196F3',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            marginRight: '8px'
                          }}
                          title="Edit Account"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDelete(account.acc_master_id)}
                          style={{
                            backgroundColor: '#f44336',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                          title="Delete Account"
                        >
                          <FaTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                marginTop: '20px',
                gap: '10px'
              }}>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    ...paginationButtonStyle,
                    backgroundColor: currentPage === 1 ? '#ccc' : '#b91c1c',
                    color: 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                  }}
                >
                  Previous
                </button>
                
                <div style={{ display: 'flex', gap: '5px' }}>
                  {[...Array(totalPages)].map((_, idx) => {
                    const page = idx + 1;
                    if (
                      page === 1 ||
                      page === totalPages ||
                      (page >= currentPage - 1 && page <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={page}
                          onClick={() => handlePageChange(page)}
                          style={{
                            ...paginationButtonStyle,
                            backgroundColor: currentPage === page ? '#b91c1c' : '#e0e0e0',
                            color: currentPage === page ? 'white' : '#333'
                          }}
                        >
                          {page}
                        </button>
                      );
                    } else if (page === currentPage - 2 || page === currentPage + 2) {
                      return <span key={page} style={{ padding: '8px' }}>...</span>;
                    }
                    return null;
                  })}
                </div>

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    ...paginationButtonStyle,
                    backgroundColor: currentPage === totalPages ? '#ccc' : '#b91c1c',
                    color: 'white',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                  }}
                >
                  Next
                </button>
              </div>
            )}

            <div style={{ textAlign: 'center', marginTop: '10px', color: '#666', fontSize: '14px' }}>
              Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, accounts.length)} of {accounts.length} entries
            </div>
          </>
        )}
      </div>

      {/* Form Section - At the bottom */}
      <div className="form-section" style={{
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ 
          textAlign: 'center', 
          marginBottom: '30px', 
          color: '#333',
          borderBottom: '2px solid #4CAF50',
          paddingBottom: '10px'
        }}>
          {editId ? 'Edit Account' : 'Add Account'}
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            {/* Region */}
            <div>
              <label style={labelStyle}>
                Region <span style={requiredStar}>*</span>
              </label>
              <select
                name="region_id"
                value={formData.region_id}
                onChange={handleChange}
                style={inputStyle}
                required
              >
                <option value="">Select Region</option>
                {regions.map(region => (
                  <option key={region.region_id} value={region.region_id}>
                    {region.region_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Branch */}
            <div>
              <label style={labelStyle}>
                Branch <span style={requiredStar}>*</span>
              </label>
              <select
                name="branch_id"
                value={formData.branch_id}
                onChange={handleChange}
                style={inputStyle}
                required
                disabled={!formData.region_id}
              >
                <option value="">Select Branch</option>
                {filteredBranches.map(branch => (
                  <option key={branch.branch_id} value={branch.branch_id}>
                    {branch.branch_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Account Type */}
            <div>
              <label style={labelStyle}>
                Account Type <span style={requiredStar}>*</span>
              </label>
              <select
                name="acc_type_id"
                value={formData.acc_type_id}
                onChange={handleChange}
                style={inputStyle}
                required
              >
                <option value="">Select Account Type</option>
                {accountTypes.map(type => (
                  <option key={type.acc_type_id} value={type.acc_type_id}>{type.acc_grp_name}</option>
                ))}
              </select>
            </div>

            {/* Account Name */}
            <div>
              <label style={labelStyle}>
                Account Name <span style={requiredStar}>*</span>
              </label>
              <input
                type="text"
                name="acc_name"
                value={formData.acc_name}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Account Name"
                required
              />
            </div>

            {/* Status */}
            <div>
              <label style={labelStyle}>
                Status <span style={requiredStar}>*</span>
              </label>
              <select
                name="account_status"
                value={formData.account_status}
                onChange={handleChange}
                style={inputStyle}
                required
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            {/* Account Code */}
            <div>
              <label style={labelStyle}>Account Code</label>
              <input
                type="text"
                name="account_code"
                value={formData.account_code}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Account Code"
              />
            </div>

            {/* Title */}
            <div>
              <label style={labelStyle}>Title</label>
              <select
                name="title"
                value={formData.title}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="">Select Title</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
                <option value="Prof">Prof</option>
              </select>
            </div>

            {/* Company Name */}
            <div>
              <label style={labelStyle}>
                Company Name <span style={requiredStar}>*</span>
              </label>
              <input
                type="text"
                name="comp_name"
                value={formData.comp_name}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Company Name"
                required
              />
            </div>

            {/* Phone */}
            <div>
              <label style={labelStyle}>Phone</label>
              <input
                type="tel"
                name="comp_phone"
                value={formData.comp_phone}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Phone"
              />
            </div>

            {/* Email */}
            <div>
              <label style={labelStyle}>Email</label>
              <input
                type="email"
                name="comp_email"
                value={formData.comp_email}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Email"
              />
            </div>

            {/* State */}
            <div>
              <label style={labelStyle}>State</label>
              <input
                type="text"
                name="comp_state"
                value={formData.comp_state}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter State"
              />
            </div>

            {/* Country */}
            <div>
              <label style={labelStyle}>Country</label>
              <input
                type="text"
                name="comp_country"
                value={formData.comp_country}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Country"
              />
            </div>

            {/* Credit Limit */}
            <div>
              <label style={labelStyle}>Credit Limit</label>
              <input
                type="number"
                name="credit_limit"
                value={formData.credit_limit}
                onChange={handleChange}
                style={inputStyle}
                placeholder="0"
                min="0"
              />
            </div>

            {/* Reference */}
            <div>
              <label style={labelStyle}>Reference</label>
              <input
                type="text"
                name="reference"
                value={formData.reference}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Reference"
              />
            </div>

            {/* Pin Code */}
            <div>
              <label style={labelStyle}>Pin Code</label>
              <input
                type="text"
                name="comp_pincode"
                value={formData.comp_pincode}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Pin Code"
              />
            </div>

            {/* Website */}
            <div>
              <label style={labelStyle}>Website</label>
              <input
                type="url"
                name="comp_website"
                value={formData.comp_website}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Enter Website"
              />
            </div>

            {/* Address */}
            <div style={{ gridColumn: 'span 3' }}>
              <label style={labelStyle}>Address</label>
              <textarea
                name="comp_add"
                value={formData.comp_add}
                onChange={handleChange}
                style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
                placeholder="Enter Address"
              />
            </div>

            {/* GST No */}
            <div>
              <label style={labelStyle}>GST No</label>
              <input
                type="text"
                name="comp_gst"
                value={formData.comp_gst}
                onChange={handleChange}
                style={inputStyle}
                placeholder="ENTER GST NO"
                maxLength="15"
              />
            </div>

            {/* PAN No */}
            <div>
              <label style={labelStyle}>PAN No</label>
              <input
                type="text"
                name="comp_pan"
                value={formData.comp_pan}
                onChange={handleChange}
                style={inputStyle}
                placeholder="ENTER PAN NO"
                maxLength="10"
              />
            </div>

            {/* E-Invoice */}
            <div>
              <label style={labelStyle}>E-Invoice</label>
              <select
                name="e_invoice"
                value={formData.e_invoice}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value={0}>No</option>
                <option value={1}>Yes</option>
              </select>
            </div>

            {/* Billwise */}
            <div>
              <label style={labelStyle}>Billwise</label>
              <select
                name="Billwise"
                value={formData.Billwise}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            {/* Buttons */}
            <div style={{ 
              gridColumn: 'span 3', 
              marginTop: '30px', 
              textAlign: 'center',
              borderTop: '1px solid #eee',
              paddingTop: '20px'
            }}>
              <button 
                type="submit" 
                disabled={loading}
                style={{
                  backgroundColor: loading ? '#ccc' : '#4CAF50',
                  color: 'white',
                  padding: '12px 30px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  marginRight: '15px',
                  fontWeight: '600',
                  minWidth: '150px'
                }}
              >
                {loading ? 'Saving...' : (editId ? 'Update Account' : 'Save Account')}
              </button>
              <button 
                type="button" 
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  padding: '12px 30px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  minWidth: '150px'
                }}
                onClick={handleReset}
                disabled={loading}
              >
                {editId ? 'Cancel' : 'Reset'}
              </button>
            </div>

            <p style={{
              gridColumn: 'span 3',
              fontSize: '12px',
              color: '#999',
              marginTop: '15px',
              textAlign: 'center'
            }}>
              Fields marked with <span style={{ color: 'red' }}>*</span> are required
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccountMaster;